/**
 * @fileoverview Agent definition for short-story-planner-v4.
 *
 * Takes a plot concept and expands it into a written plot outline,
 * plot threads, and suggested characters for short stories.
 *
 * Key difference from v3: No storylines or beats. The writtenPlot is the
 * single source of truth, and plot threads replace story questions.
 *
 * @category narrative.story.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'short-story-planner-v4',
  kind: 'primitive',
  name: 'Story Planner (Short-Form v4)',
  description: 'Takes a plot concept and expands it into a written plot outline, plot threads, and suggested characters for short stories. No storylines or beats — writtenPlot is the single source of truth.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.planning',
    usedBy: ['use-short-story-planner.ts'],
    relatedAgents: ['plot-ideas-generator-v2', 'single-chapter-story-generator-v2'],
  },
  recommendedModels: [
    { modelProvider: 'anthropic', modelName: 'claude-opus-4-5' },
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
    { modelProvider: 'openai', modelName: 'gpt-5.2' },
  ],
};
